export type DeckType = 'locationDeck' | 'animalsDeck';

export const LOCATION_QUESTIONS = [
  "What kind of clothing would you typically wear here?",
  "How long have you been working in this place?",
  "What's the busiest time of day here?",
  "What's the most dangerous thing about this place?",
  "What's your favorite thing about this place?",
  "What would you find on the floor in this place?",
  "Who was the last person you saw here?",
  "What's the weather like in this location?",
  "How warm would you say this place is?",
  "What sounds can you typically hear in this place?",
  "What smells are common in this location?",
  "What is the most common item in this place?",
  "What's the most valuable item in this place?"
];

export const ANIMAL_QUESTIONS = [
  "What sound does you typically make?",
  "Where would you naturally be",
  "What do you primarily eat?",
  "Whats your favorite weather?",
  "What’s your daily routine like?",
  "Are you more of a morning person or a night owl?",
  "How do you feel about rainy days?",
  "What's your favourite season, and why?",
  "Are you more of a social butterfly or a lone wolf?",
  "What’s the biggest misunderstanding people have about you?",
  "How long is your typical nap?",
  "What do you think about humans?",
  "What's your favorite feature about yourself?",
  "What time of day are you most active?",
  "How much space would you take up on a standard sofa?",
  "What's your preferred method of travel?",
  "How are your table manners?",
  "What's your favorite way to spend your free time?",
  "What's the most dangerous thing about you?",
  "How long is your life span?",
  "What kind of habitat do you prefer?",
  "What's your favorite thing about this animal?",
  "How do you protect yourself from predators?",
  "What's the view like from your home?",
  "Describe your ideal thermostat setting.",
  "City life or country living for you?",
  "How do you feel about neighbours?"
];

/**
 * Get appropriate questions based on the current deck type
 */
export const getQuestionsForDeck = (currentDeck: string): string[] => {
  switch (currentDeck) {
    case 'animalsDeck':
      return ANIMAL_QUESTIONS;
    case 'locationDeck':
    default:
      return LOCATION_QUESTIONS;
  }
};

/**
 * Get a random question from the appropriate deck
 */
export const getRandomQuestionForDeck = (currentDeck: string): string => {
  const questions = getQuestionsForDeck(currentDeck);
  const randomIndex = Math.floor(Math.random() * questions.length);
  return questions[randomIndex];
}; 